import React from 'react';
const IconRatingStarFill = () => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M21.8398 8.27998L15.7598 7.38998L13.0898 1.97998H10.9098L8.23977 7.38998L2.15977 8.27998L1.50977 10.26L5.90977 14.55L4.83977 20.78L6.39977 21.91L11.9998 18.97L17.5998 21.91L19.1598 20.78L18.0898 14.55L22.4898 10.26L21.8398 8.27998Z", fill: "#2D2E2E" })));
};
export default IconRatingStarFill;
//# sourceMappingURL=ratingStarFill.js.map
// @zapier/design-system@5.23.2 (dd3f72af2)
